import { render, staticRenderFns } from "./SocialNetworkFooter.vue?vue&type=template&id=33bd2343&"
import script from "./SocialNetworkFooter.vue?vue&type=script&lang=ts&"
export * from "./SocialNetworkFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports